import(/* webpackMode: "eager" */ "/home/u677803425/domains/indocuttinglaser.com/public_html/.builds/source/cutting-main/src/app/galeri/page.tsx");
